import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postTravelAddonSlice = createSlice({
  name: "postTravelAddon",
  initialState,
  reducers: {
    postTravelAddonStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postTravelAddonSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postTravelAddonFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postTravelAddonStart,
  postTravelAddonSuccess,
  postTravelAddonFailure,
  clearError,
  clearMessage,
} = postTravelAddonSlice.actions;

export default postTravelAddonSlice.reducer;
